import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import { PostApi } from "../../api/api-service";
import { API_Path } from "../../Const";
import SuccessModal from "./SuccessModal";

export default function EmailAgentModal({ show, onHide, title, pData, type, pdfData }) {
    const [btnLoader, setBtnLoader] = useState(false);
    const [successMDL, setSuccessMDL] = useState(false);
    const handleSccessHide = () => setSuccessMDL(false);
    const setSubmitData = async (formData) => {
        let date = new Date();
        let data = {
            propertyId: pData?.uId || "",
            propertyTitle: pData?.title || "",
            fullName: formData.fullName,
            email: formData.email,
            phoneNumber: formData.number,
            message: formData.massage,
            types: type,
            status: "pending",
            inquiryDate: date.toISOString(),
            isActive: true,
        };
        try {
            setBtnLoader(true);
            const res = await PostApi(API_Path.PropertyInquiry, data);
            if (res && res.data.success) {
                if (pdfData && pdfData !== "") window.open(pdfData);
                toast.success(res.data.message);
                setSuccessMDL(true);
                onHide();
            } else toast.error(res.data.message);
            setBtnLoader(false);
        } catch (error) {
            setBtnLoader(false);
        }
    };

    return (
        <>
            <Modal size="md" aria-labelledby="contained-modal-title-vcenter" className="modal-details" show={show} centered>
                <Modal.Header className="justify-content-between">
                    <Modal.Title>{title ? title : "For more information, email the agent."}</Modal.Title>
                    <button type="button" onClick={onHide} className="close-icon-style">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={{
                            fullName: "",
                            email: "",
                            number: "",
                            massage: "",
                            // massage: "I would like to find out more about your agency and properties. Please contact me at your earliest convenience.",
                        }}
                        validationSchema={Yup.object().shape({
                            fullName: Yup.string().required("Full name is required."),
                            email: Yup.string()
                                .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Enter a valid email address.")
                                .email("Your email address must be in the format of name@domain.com.")
                                .required("Email is required."),
                            number: Yup.string().min(9, "Phone number is required.").required("Phone number is required."),
                            massage: Yup.string().required("Massage is required."),
                        })}
                        onSubmit={(values, { resetform }) => {
                            setSubmitData(values, resetform);
                        }}
                    >
                        {(runform) => (
                            <Form onSubmit={runform.handleSubmit}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="comn-input-main">
                                            <label>
                                                Full Name <span className="text-danger">*</span>
                                            </label>
                                            <Field type="text" placeholder="Enter full name" name="fullName" className={`form-control ${runform.errors.fullName && runform.touched.fullName ? "error-bdr" : ""}`} />
                                            <ErrorMessage name="fullName" component="span" className="error-message" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="comn-input-main">
                                            <label>
                                                Email <span className="text-danger">*</span>
                                            </label>
                                            <Field type="email" placeholder="Enter email" name="email" className={`form-control ${runform.errors.email && runform.touched.email ? "error-bdr" : ""}`} />
                                            <ErrorMessage name="email" component="span" className="error-message" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="comn-input-main">
                                            <label>
                                                Phone Number <span className="text-danger">*</span>
                                            </label>
                                            <Field name="number">
                                                {({ field, form }) => {
                                                    return <PhoneInput {...field} country={"ae"} className={form.errors?.number && form.touched?.number ? "input-error" : ""} value={runform.values.number} onChange={(phone) => form.setFieldValue("number", phone)} />;
                                                }}
                                            </Field>
                                            <ErrorMessage name="number" component="span" className="error-message" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="comn-input-main">
                                            <label>
                                                Massage <span className="text-danger">*</span>
                                            </label>
                                            <Field as="textarea" placeholder="Enter Massage" rows={4} name="massage" className={`form-control ${runform.errors.massage && runform.touched.massage ? "error-bdr" : ""}`} />
                                            <ErrorMessage name="massage" component="span" className="error-message" />
                                        </div>
                                    </div>
                                    <div className="send-btn">
                                        <button type="submit" className="button" disabled={btnLoader}>
                                            {btnLoader ? (
                                                <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                                            ) : (
                                                <>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                        <path d="M13.3 2.7H2.7A1.3 1.3 0 0 0 1.3 4v8a1.3 1.3 0 0 0 1.4 1.3h10.6a1.3 1.3 0 0 0 1.4-1.3V4a1.3 1.3 0 0 0-1.4-1.3zm0 2.6L8 8.7 2.7 5.3V4L8 7.3 13.3 4z" fill="#fff"></path>
                                                        <path fill="none" d="M0 0h16v16H0z"></path>
                                                    </svg>
                                                    Send Email
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
            <SuccessModal show={successMDL} onHide={handleSccessHide} />
        </>
    );
}
